import React from 'react';
import styles from '../../styles/GruposStyles/PantallaDeGrupos.module.css';

const ActionButtons = ({ onView, onEdit, onDelete }) => {
  const handleView = () => {
    if (onView) onView();
  };

  const handleEdit = () => {
    if (onEdit) onEdit();
  };

  const handleDelete = () => {
    if (onDelete) onDelete();
  };

  return (
    <div className={styles.actionButtonsContainer}>
      <img
        src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/e054564ed1bcb4be6d0f8968ecf39fd825a798c5?placeholderIfAbsent=true"
        alt="Ver detalles"
        className={styles.actionButton}
        onClick={handleView}
        style={{ cursor: 'pointer' }}
      />
      <img
        src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/a03a9a16af0d11e1982fced03460e479acbb5851?placeholderIfAbsent=true"
        alt="Editar"
        className={styles.actionButton}
        onClick={handleEdit}
        style={{ cursor: 'pointer' }}
      />
      <img
        src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/98cae3bdddd3b7d51cf234a8e61559e5ad2f1cfc?placeholderIfAbsent=true"
        alt="Eliminar"
        className={styles.actionButton}
        onClick={handleDelete}
        style={{ cursor: 'pointer' }}
      />
    </div>
  );
};

export default ActionButtons;
